import {TARGET_TYPES} from '@/utils/constants/saleTargetConstants'

export const DEFAULT_INTL = 'en-US'

export const SALES_TARGETS_QUERY_KEY = 'salesTargets'

export const COUNTRIES_QUERY_KEY = 'countries'
export const LANGUAGES_QUERY_KEY = 'languages'

export const OKTA_AUTH_CONFIG_KEY = 'okta-auth-config'
export const OKTA_TOKEN_STORAGE_KEY = 'okta-token-storage'
export const SALES_TARGETS_ACTIVITIES_QUERY_KEY = 'salesTargetsActivities'
export const TEXT_TAG_ACTIVATION_CHAR = '$'
export const SALES_TARGET_MAIN_GROUP = [
  TARGET_TYPES.MainTarget,
  TARGET_TYPES.ProductTarget,
  TARGET_TYPES.ProductTargetLayered,
  TARGET_TYPES.MonthlyTargetLayered,
]
export const SALES_TARGET_PREREQUISITE_GROUP = [
  TARGET_TYPES.MonthlyTargetPrerequistite,
  TARGET_TYPES.ProductTargetPrerequisite,
]

export const COUNTRY_CODES = {
  EGYPT: 'EG',
  KSA: 'SA',
}

export const COUNTRY_CODES_FREQUENCY = []
export const COUNTRY_CODES_EXCLUDE_TAX_FROM_GOAL = [COUNTRY_CODES.KSA]
export const APPLICATION_ID = {
  MX: 1,
  EG: 30,
  PE: 528,
  EC: 33,
  KSA: 29,
  SA: 29,
  CO: 7,
  AR: 500
};

export const ALLOW_SAME_DATE_ACTIVITY_COUNTRIES = [COUNTRY_CODES.EGYPT, COUNTRY_CODES.KSA];

export const COUNTRY_LANGUAGES_CODES = {
  MX: [
    {
      languageId: 1,
      code: 'en',
      title: 'English',
    },
    {
      languageId: 2,
      code: 'es_MX',
      title: 'Spanish (Mexico)',
    },
  ],
  PE: [
    {
      languageId: 1,
      code: 'en',
      title: 'English',
    },
    {
      languageId: 2,
      code: 'es_PE',
      title: 'Spanish (Peru)',
    },
  ],
  EC: [
    {
      languageId: 1,
      code: 'en',
      title: 'English',
    },
    {
      languageId: 2,
      code: 'es_EC',
      title: 'Spanish (Ecuador)',
    },
  ],
  EG: [
    {
      languageId: 1,
      code: 'en',
      title: 'English',
    },
    {
      languageId: 2,
      code: 'ar_EG',
      title: 'Arabic- Egypt',
    },
  ],
  SA: [
    {
      languageId: 1,
      code: 'en',
      title: 'English',
    },
    {
      languageId: 2,
      code: 'ar_SA',
      title: 'Arabic- KSA',
    },
  ],
   AR: [
    {
      languageId: 1,
      code: 'en',
      title: 'English',
    },
    {
      languageId: 2,
      code: 'es_AR',
      title: 'Spanish (Argentina)',
    },
    {
      languageId: 3,
      code: 'zh_AR',
      title: 'Chinese (Argentina)',
    },
  ],
  CO: [
    {
      languageId: 1,
      code: 'en',
      title: 'English',
    },
    {
      languageId: 2,
      code: 'es',
      title: 'Spanish (Colombia)',
    },
  ],
}
